'use client'

import type { RefObject } from 'react'
import { useCallback, useEffect, useLayoutEffect, useState } from 'react'

export const useArrowPosition = (
  slideRef: RefObject<HTMLDivElement[] | null>,
  arrowVerticalPosition: 'image' | 'slide',
  overflowDesktop?: boolean
) => {
  const [arrowPosition, setArrowPosition] = useState({
    vertical: '0px',
    horizontal: '0px',
  })

  const updateSize = useCallback(() => {
    // get the first image of carousel to calculate the center of the arrows
    const firstImage = slideRef.current?.[0]?.querySelector(
      'img, video, div[style*="background-image"]'
    ) as HTMLElement
    const imageHeight = firstImage?.offsetHeight
    const slideHeight = slideRef.current?.[0]?.offsetHeight
    const positions = {
      image: imageHeight ? imageHeight / 2 - 20 : 0,
      slide: slideHeight ? slideHeight / 2 - 20 : 0,
    }
    setArrowPosition({
      // middle of the image or slide minus half the size of the arrow
      vertical: positions[arrowVerticalPosition] + 'px',
      horizontal: overflowDesktop
        ? '11.5%'
        : `calc(-1 * var(--arrow-size) - var(--arrow-offset-x))`,
    })
  }, [arrowVerticalPosition, overflowDesktop, slideRef])
  // make sure the arrow position is updated on browser resizing
  useLayoutEffect(() => {
    window.addEventListener('resize', updateSize)
    return () => {
      window.removeEventListener('resize', updateSize)
    }
  }, [overflowDesktop, updateSize])
  useEffect(() => {
    // without it the arrows are positioned by default by the lib
    setTimeout(() => {
      updateSize()
    }, 1)
  }, [updateSize])
  return arrowPosition
}
